import React from "react";
import i18n from 'i18next'

class Timeline extends React.Component {
  generateList(item) {
    if (Array.isArray(item)) {
      let returnVal = [];
      for (const subItem of item) {
        if (subItem.li) {
          returnVal.push(<li key={subItem.li}>{i18n.t(subItem.li)}</li>);
        }
        if (subItem.ul) {
          returnVal.push(<ul key={subItem.ul}>{this.generateList(subItem.ul)}</ul>);
        }
      }
      return returnVal;
    }
    if (item && item.ul) {
      return (<ul>{this.generateList(item.ul)}</ul>)
    }
    return "";
  }
  render() {
    const msg = this.props.Message;
    return (
      <section id="timeline">
        <div className="container">
          <div className="title-block">
            <h2>{i18n.t(msg.timeline)}</h2>
            {/* <p className="subtitle-block">{msg.timelineSubtitle}</p> */}
          </div>
          {
            msg.timelineData.map((item, index) => {
              return (
                <div className={`col col-${ index%2 === 0 ? "odd" : "even"}`} key={index}>
                  {/* <p className="date">{item.date}</p> */}
                  <div className="icon">
                    <img src="images/rightpointicon.png" alt="point icon" />
                    {index !== msg.timelineData.length -1 && <div className="icon-line"/>}
                  </div>
                  <div>
                    <h4>{i18n.t(item.title)}</h4>
                    {typeof item.desc === "string"
                      ? <p className="content">{i18n.t(item.desc)}</p>
                      : this.generateList(item.desc)
                    }
                  </div>
                </div>
              )
            })
          }
        </div>
      </section>
    );
  }
}

export default Timeline;